export type WheelManagementWarningModalPayload = {
  title: string
  confirmLabel: string
  description: string
}

export function buildSubCompetencyEditWarningModal(
  subCompetencyName: string,
): WheelManagementWarningModalPayload {
  return {
    title: 'Save destructive sub-competency changes?',
    confirmLabel: 'Save and reset assessments',
    description: `Saving changes to "${subCompetencyName}" will reset existing self and guided assessment scores for this sub-competency.`,
  }
}
